import { useEffect } from "react";
import {Rover} from './Rover';
import {Field} from './Field';
import PointsResult from './Points-Result';
import FieldResult from './Field-Result';
import ObstaclesResult from './Obstacles-Result';
import {Obstacles} from './Obstacles';
import {Points} from './Points';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import PageNotFound from './errors/404';
import InternalServerError from './errors/500';
import ErrorBoundary from './components/errorBoundary';
import CookieConsent, {
  getCookieConsentValue,
  Cookies,
} from "react-cookie-consent";
import ReactGA from "react-ga4";

const TRACKING_ID = "G-KDC397W07D"; 

function App(props) {
  const handleAcceptCookie = () => {
      ReactGA.initialize(TRACKING_ID);
  };

  const handleDeclineCookie = () => {
    //remove google analytics cookies
    Cookies.remove("_ga");
    Cookies.remove("_gat");
    Cookies.remove("_gid");
  };

  useEffect(() => {
    const isConsent = getCookieConsentValue();
    if (isConsent === "true") {
      handleAcceptCookie();
    }
  }, []); 
  
  const simulateCookieConsentAcceptClick = () => {
    document.getElementById("rcc-confirm-button").click();
  }
  
  return (
    <>
      <div className="topbar">
        <a href="/"><img src="/brand.png" alt="GNSS Route Planning logo"></img></a>
        <a href="https://www.navmatix.com/" target="_blank" rel="noopener noreferrer"><img src="author.png" alt="Navmatix logo"></img></a>
      </div>
      <BrowserRouter>
      <div className="app-container">
        <Switch>
          <Route exact path="/">
            <ErrorBoundary>
              <Rover store = {props.store}/>
            </ErrorBoundary>
          </Route>
          <Route  path='/Field'>
          <ErrorBoundary>
            <Field store = {props.store}/>
            </ErrorBoundary>
          </Route>
          <Route  path='/Field-result'>
          <ErrorBoundary>
            <FieldResult store = {props.store}/>
            </ErrorBoundary>
          </Route>
          <Route  path='/Obstacles'>
          <ErrorBoundary>
            <Obstacles store = {props.store}/>
            </ErrorBoundary>
          </Route>
          <Route  path='/Obstacles-Result'>
          <ErrorBoundary>
            <ObstaclesResult store = {props.store}/>
            </ErrorBoundary>
          </Route>
          <Route  path='/Points'>
          <ErrorBoundary>
            <Points store = {props.store}/>
            </ErrorBoundary>
          </Route>
          <Route  path='/Points-Result'>
          <ErrorBoundary>
            <PointsResult store = {props.store}/>
            </ErrorBoundary>
          </Route>
          <Route  path='/errors/404'>
            <PageNotFound/>
          </Route>
          <Route  path='/errors/500'>
            <InternalServerError/>
          </Route>
          <Route component={PageNotFound} />          
        </Switch>
      </div>
      </BrowserRouter>
      <CookieConsent
        overlay
        onAccept={handleAcceptCookie}
        onDecline={handleDeclineCookie}
        overlayStyle={{ zIndex: "1051" }}
      >
        <div className="modal fade show" tabIndex={-1} role="dialog" aria-labelledby="infoCookieConsent" aria-hidden="false">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title" id="infoCookieConsent">We use cookies</h2>
              </div>
              <div className="modal-body">
                <p>We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume that you agree with it.</p>
                <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noreferrer" className="btn btn-outline-secondary">Privacy policy</a>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary modal-btn" data-dismiss="modal" aria-label="Accept cookies" onClick={simulateCookieConsentAcceptClick}>
                  I understand
                </button>
              </div>
            </div>
          </div>
        </div>
      </CookieConsent>
    </>
  );
}

export default App;
